import styled from 'styled-components'

interface ErrorIconProps {
  color?: string
}

const ErrorIconSvg = styled.svg<{ $color?: string }>`
  path {
    fill: ${({ $color, theme }) => $color || theme.colors.danger};
  }
`

export default function ErrorIcon({ color }: ErrorIconProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '20px', width: '20px' }}>
      <ErrorIconSvg
        $color={color}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path d="M17.6504 10.196C17.6504 5.97107 14.225 2.54565 10 2.54565C5.77502 2.54565 2.34961 5.97107 2.34961 10.196C2.34961 14.421 5.77502 17.8464 10 17.8464V19.196C5.02944 19.196 1 15.1666 1 10.196C1 5.22548 5.02944 1.19604 10 1.19604C14.9706 1.19604 19 5.22548 19 10.196C19 15.1666 14.9706 19.196 10 19.196V17.8464C14.225 17.8464 17.6504 14.421 17.6504 10.196Z" />
        <path d="M10.7936 5.19604L10.6705 12.2412H9.31615L9.19303 5.19604H10.7936ZM10.0001 15.196C9.46662 15.196 9.01519 14.7583 9.02887 14.2248C9.01519 13.6913 9.46662 13.2535 10.0001 13.2535C10.52 13.2535 10.9714 13.6913 10.9714 14.2248C10.9714 14.7583 10.52 15.196 10.0001 15.196Z" />
      </ErrorIconSvg>
    </div>
  )
}
